<template>
  <div class="student">
    <Form :model="searchCondition" :label-width="72" inline>
      <FormItem label="学员状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option v-for="item in studentStatus" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="学生名称">
        <Input
          v-model="searchCondition.nickname"
          placeholder="请输入学生关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          type="number"
          v-model="searchCondition.mobile"
          placeholder="请输入手机号"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="用户身份">
        <Select v-model="searchCondition.visitor" style="width:200px;" clearable>
          <Option v-for="item in visitors" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">新增学员</Button>
      <!-- <Button type="primary" @click="onImport()" class="btn-margin-right">批量导入</Button> -->
      <Button type="primary" @click="onExport('all')" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onWatch" class="btn-margin-right">查看报表</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/user"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="uid"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.nickname"></span>
          </div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDetail(row)">编辑</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              @click="onForbidden(row)"
            >{{row.status == 1 ? '禁用' : '启用'}}</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onBuyRecord(row)">购买记录</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onResetPwd(row)">重置密码</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" type="text" @click="onExport('select')">导出所选</Button>
        </template>
      </Grid>
    </div>
    <ExportsModal
      title="导出学员"
      :type="1"
      :params="exportForm"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></ExportsModal>
  </div>
</template>

<script>
import { StudentStatus } from "@/utils/enums";
import ExportsModal from "@/components/ExportsModal";

export default {
  name: "student",
  components: {
    ExportsModal
  },
  data() {
    return {
      studentStatus: StudentStatus.getOptions(),
      tableColumns: [
        { title: "学生名称", slot: "c1", minWidth: 200 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 150 },
        { title: "QQ", key: "qq", align: "center", minWidth: 100 },
        { title: "用户身份", key: "visitor_name", align: "center", minWidth: 100 },
        { title: "所属分类", key: "classify_name", align: "center", minWidth: 150 },
        { title: "状态", key: "statusName", align: "center", minWidth: 100 },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          fixed: "right",
          minWidth: 200
        }
      ],
      searchCondition: {
        status: "",
        nickname: "",
        mobile: "",
        visitor:'',
        init: function() {
          this.status = "";
          this.nickname = "";
          this.mobile = "";
          this.visitor = "";
        }
      },
      selectRows: [],
      showExportModal: false,
      exportForm: {},
      default_pass: "",
      visitors:[
        {key: 2, value:' 用户'},
        {key: 1, value: '游客'}
      ]
    };
  },
  created() {
    this.$http.get("/api/commonSetting").then(data => {
      this.default_pass = data.default_pass;
    });
  },
  methods: {
    // on-event
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.statusName = StudentStatus.getValue(i.status);
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.classify_name = i.classify && i.classify.title
        i.visitor_name = i.visitor == 1 ? '游客' : '用户';
      });
    },
    onSelectionChange(items) {
      this.selectRows = items;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.$router.push({
        name: "StudentEdit"
      });
    },
    onImport() {
      this.$router.push({
        name: "StudentImports",
        query: {
          type: "student"
        }
      });
    },
    onExport(row) {
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要导出的学员");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.uid);
        });
        this.exportForm.id = idAry.join();
      } else if (row == "all") {
        this.exportForm.status = this.searchCondition.status;
        this.exportForm.nickname = this.searchCondition.nickname;
      }
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: "StudentExports",
        query: {
          type: "student"
        }
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "StudentEdit",
        query: {
          id: row.uid
        }
      });
    },
    onForbidden(row) {
      if (row.status == 1) {
        this.$Modal.confirm({
          title: "提示",
          content: "禁用后此学员将无法登录网站，确定要禁用该学员吗？",
          onOk: () => {
            this.$http.put("/api/user/on/" + row.uid).then(() => {
              this.$refs.grid.refresh();
            });
          }
        });
      } else {
        this.$http.put("/api/user/on/" + row.uid).then(() => {
          this.$refs.grid.refresh();
        });
      }
    },
    onBuyRecord(row) {
      this.$router.push({
        name: "OrderCourse",
        query: {
          mobile: row.mobile
        }
      });
    },
    onResetPwd(row) {
      this.$Modal.confirm({
        title: "提示",
        content:
          "密码将重置为" + this.default_pass + "，请提醒用户及时修改密码。",
        onOk: () => {
          this.$http.put("/api/user/resetPwd/" + row.uid).then(() => {
            this.$Message.success("密码重置成功！");
          });
        }
      });
    }
    // other
    // request
  }
};
</script>
